import Color from "colorjs.io";

const rangeOptions = { space: "lch", outputSpace: "srgb" };

const prevalenceColors = [
  new Color("rgb(255, 232, 164)"),
  new Color("#FFDB6C"),
  new Color("rgb(255, 219, 108)"),
  new Color("#FFCB2B"),
  new Color("#FFB347"),
  new Color("#ED9211"),
  new Color("#ED9211"),
  new Color("#A51930"),
  new Color("#790216"),
  new Color("#580F1C"),
  new Color("#3B000B")
];

const prevalenceGrade = [
  new Color("rgb(255, 232, 164)"),
  new Color("rgb(255, 219, 108)"),
  new Color("rgb(255, 203, 43)"),
  new Color("rgb(255, 179, 71)"),
  new Color("rgb(237, 146, 17)"),
  new Color("rgb(165, 25, 48)"),
  new Color("rgb(121, 2, 22)"),
  new Color("rgb(88, 15, 28)")
];

const prevalenceRanges = [
  prevalenceColors[0].range(prevalenceColors[1], rangeOptions),
  prevalenceColors[1].range(prevalenceColors[2], rangeOptions),
  prevalenceColors[2].range(prevalenceColors[3], rangeOptions),
  prevalenceColors[3].range(prevalenceColors[4], rangeOptions),
  prevalenceColors[4].range(prevalenceColors[5], rangeOptions),
  prevalenceColors[5].range(prevalenceColors[6], rangeOptions),
  prevalenceColors[6].range(prevalenceColors[7], rangeOptions),
  prevalenceColors[7].range(prevalenceColors[8], rangeOptions),
  prevalenceColors[8].range(prevalenceColors[9], rangeOptions),
  prevalenceColors[9].range(prevalenceColors[10], rangeOptions),
  prevalenceColors[9].range(prevalenceColors[10], rangeOptions)
];

const vulnerabilityColors = [
  new Color("#FFF8E2"),
  new Color("#FFE8A4"),
  new Color("#FFE8A4"),
  new Color("#FFDB6C"),
  new Color("#FFCB2B"),
  new Color("#FFB347"),
  new Color("#FF5C45"),
  new Color("#FF5C45"),
  new Color("#FF2304"),
  new Color("#C21800"),
  new Color("#821000")
];

const vulnerabilityGrade = [
  new Color("#FFF8E2"),
  new Color("#FFE8A4"),
  new Color("#FFDB6C"),
  new Color("#FFCB2B"),
  new Color("#FFB347"),
  new Color("#FF5C45"),
  new Color("#FF2304"),
  new Color("#C21800"),
  new Color("#821000")
];

const vulnerabilityRanges = [
  vulnerabilityColors[0].range(vulnerabilityColors[1], rangeOptions),
  vulnerabilityColors[1].range(vulnerabilityColors[2], rangeOptions),
  vulnerabilityColors[2].range(vulnerabilityColors[3], rangeOptions),
  vulnerabilityColors[3].range(vulnerabilityColors[4], rangeOptions),
  vulnerabilityColors[4].range(vulnerabilityColors[5], rangeOptions),
  vulnerabilityColors[5].range(vulnerabilityColors[6], rangeOptions),
  vulnerabilityColors[6].range(vulnerabilityColors[7], rangeOptions),
  vulnerabilityColors[7].range(vulnerabilityColors[8], rangeOptions),
  vulnerabilityColors[8].range(vulnerabilityColors[9], rangeOptions),
  vulnerabilityColors[9].range(vulnerabilityColors[10], rangeOptions),
  vulnerabilityColors[9].range(vulnerabilityColors[10], rangeOptions)
];

const govresponseColors = [
  new Color("#E9FFF2"),
  new Color("#CAF1DB"),
  new Color("#CAF1DB"),
  new Color("#A0DDBA"),
  new Color("#80C29C"),
  new Color("#77A48A"),
  new Color("#77A48A"),
  new Color("#007373"),
  new Color("#006C7A"),
  new Color("#004851"),
  new Color("#00282E")
];

const govresponseGrade = [
  new Color("#E9FFF2"),
  new Color("#CAF1DB"),
  new Color("#A0DDBA"),
  new Color("#80C29C"),
  new Color("#77A48A"),
  new Color("#007373"),
  new Color("#006C7A"),
  new Color("#004851"),
  new Color("#00282E")
];

const govresponseRanges = [
  govresponseColors[0].range(govresponseColors[1], rangeOptions),
  govresponseColors[1].range(govresponseColors[2], rangeOptions),
  govresponseColors[2].range(govresponseColors[3], rangeOptions),
  govresponseColors[3].range(govresponseColors[4], rangeOptions),
  govresponseColors[4].range(govresponseColors[5], rangeOptions),
  govresponseColors[5].range(govresponseColors[6], rangeOptions),
  govresponseColors[6].range(govresponseColors[7], rangeOptions),
  govresponseColors[7].range(govresponseColors[8], rangeOptions),
  govresponseColors[8].range(govresponseColors[9], rangeOptions),
  govresponseColors[9].range(govresponseColors[10], rangeOptions),
  govresponseColors[9].range(govresponseColors[10], rangeOptions)
];

export const colorScales = {
  prevalenceColors,
  vulnerabilityColors,
  govresponseColors
};

export const colorRanges = {
  prevalenceRanges,
  vulnerabilityRanges,
  govresponseRanges
};

export const colorGrades = {
  prevalenceGrade,
  vulnerabilityGrade,
  govresponseGrade
};
